import dayjs from 'dayjs'
import { TEditAppealTimeSlot } from 'feature/appeals/type'

export type TimeSlotsObject = Record<string, string | number>

//  приведение данных о таймслоте к нужному виду для отправки

export const prepareTimeSlotsToSubmit = (
  obj: TEditAppealTimeSlot[],
): TEditAppealTimeSlot[] => {
  const newArray = obj.map(({ date, id }) => ({
    date: dayjs(date).format('YYYY-MM-DD'),
    id,
  }))
  return newArray
}
